<template>
  <div>
    <editor
      class="editor"
      id="tinymce"
      v-model="value"
      :init="editorInit"
    ></editor>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import "tinymce/themes/silver";
import "tinymce/plugins/noneditable";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/textcolor";
import Editor from "@tinymce/tinymce-vue";
export default {
  //name: MyEditor,
  components: {
    Editor
  },
  props: {
    content: {
      type: String,
      defalt: ""
    },
    trigger: {
      type: Boolean,
      defalt: false
    },
    pink: {
      type: String,
      defalt: ""
    }
  },
  computed: {
    value: {
      get() {
        return this.content;
      },
      set(val) {
        this.$emit("setData", val);
      }
    }
  },
  watch: {
    trigger() {
      this.addPink();
    },
    edit() {
      if (!this.edit) {
        tinymce.editors.tinymce.setContent(this.content);
      }
      tinymce.editors.tinymce
        .getBody()
        .setAttribute("contenteditable", this.edit);
    }
  },
  data() {
    return {
      editorInit: {
        base_url: "/tinymce",
        language_url: "/tinymce/langs/zh_CN.js", // 语言包的路径
        language: "zh_CN", //语言
        skinUrl: "/tinymce/skins/ui/oxide", // skin路径
        height: "100%", //编辑器高度
        branding: false, //是否禁用“Powered by TinyMCE”
        menubar: false, //顶部菜单栏显示
        statusbar: false,
        plugins: "noneditable",
        toolbar: ""
      },
      oldDom: []
    };
  },
  mounted() {
    tinymce.init({});
    setTimeout(() => {
      tinymce.editors.tinymce.getBody().setAttribute("contenteditable", true);
    }, 100);
  },
  methods: {
    addPink() {
      if (tinymce.activeEditor.id === "tinymce") {
        tinymce.editors.tinymce.execCommand(
          "mceInsertContent",
          false,
          this.pink
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
